import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Whatsapp from "../components/util/Whatsapp";

const ATUALIZADA_EM = "1º de outubro de 2026";

const H2 = ({ children }) => <h2 className="text-2xl xl:text-3xl font-semibold mt-12 mb-4">{children}</h2>;
const P = ({ children }) => <p className="text-lg leading-relaxed text-gray-700 mb-4">{children}</p>;

const Privacy = () => {
  useEffect(() => {
    const anterior = document.title;
    document.title = "Política de Privacidade | Hawx Soluções";
    return () => {
      document.title = anterior;
    };
  }, []);

  return (
    <>
      <Header />
      <main className="bg-white">
        <div className="text-black w-3/4 mx-auto xl:pt-48 pt-32 pb-24 xl:pb-32 max-w-3xl">
          <p className="text-sm font-semibold uppercase tracking-widest text-pattern mb-4">Institucional</p>
          <h1 className="text-4xl xl:text-5xl font-semibold leading-[1.1] mb-4">Política de Privacidade</h1>
          <p className="text-base text-gray-500 mb-10">{`Explicamos aqui, de forma simples, como cuidamos dos seus dados. Atualizado em ${ATUALIZADA_EM}.`}</p>

          <H2>Em resumo</H2>
          <P>
            Este site não pede nenhum dado seu e não usa rastreamento. Abaixo estão os detalhes.
          </P>

          <H2>O que o site coleta</H2>
          <P>
            Nada que você precise digitar: não há formulário, cadastro ou senha. Como todo site, o nosso usa um servidor para ficar no ar e exibe o selo do Reclame Aqui no rodapé. Esses serviços recebem informações técnicas do navegador, como o endereço IP, apenas para que a página seja exibida. Isso não identifica você e não é usado para nenhuma outra finalidade.
          </P>

          <H2>Cookies e rastreamento</H2>
          <P>
            Não utilizamos cookies próprios nem ferramentas de rastreamento. Se isso mudar, esta página será atualizada antes.
          </P>

          <H2>Contato pelo WhatsApp ou e-mail</H2>
          <P>
            As informações que você compartilhar em uma conversa são usadas apenas para atender você e não são repassadas a terceiros.
          </P>

          <H2>Seus direitos</H2>
          <P>
            Pela Lei Geral de Proteção de Dados, você pode pedir para consultar, corrigir ou excluir dados seus. Basta escrever para contato@hawx.com.br. Respondemos pelo mesmo canal.
          </P>

          <H2>Responsável</H2>
          <P>
            Hawx Soluções, CNPJ 55.357.499/0001-80. Contato: contato@hawx.com.br.
          </P>

          <H2>Atualizações</H2>
          <P>
            Quando houver mudanças, a nova versão será publicada nesta página, com a data no topo.
          </P>
        </div>
      </main>
      <Whatsapp />
      <Footer />
    </>
  );
};

export default Privacy;
